import React, { useState, useEffect, useRef } from "react";

import "../../css/MainReport.css";

import DropdownProblemType from "../Menu/DropdownProblemType";
import CreateMap from "../Menu/CreateMap";
import SecureStorage from "react-secure-storage";
import { saveDataLatLon } from "../../store/MapPositionSlice";

import noImg from "../../assets/image/no_select.png";

import { Modal } from "bootstrap";

import html2canvas from "html2canvas";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";

import ic_porpor from "../../assets/icon/ic-porpor.png";
import ic_fondue from "../../assets/icon/ic-fondue.png";
import save from "../../assets/icon/save-icon.png";

import * as funcAll from "../../util/api";

///////////////// Redux ////////////////////
import { useSelector, useDispatch } from "react-redux";

export default function MainReportEN(props) {
  const globalData = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();

  const [detailReport, setDetailReport] = useState("");
  const [imgReport, setImgReport] = useState(noImg);
  const [reportMap, setReportMap] = useState(null);
  const inputFile = useRef(null);
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const [listProblemTypeAll, setListProblemTypeAll] = useState([]);
  const [selectedProblemType, setSelectedProblemType] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState(8662);

  const [alert_header, setAlertHeader] = useState(); //หัวข้อ alert
  const [alert_content, setAlertContent] = useState(); //รายละเอียก alert
  const [alert_description, setAlertDescription] = useState(); //รายละเอียก alert

  const modal_alert_ref = useRef(); //สำหรับ alert
  const [modal_alert_close, setModalAlertClose] = useState(null); //สำหรับ alert

  const modal_preview_ref = useRef(); //สำหรับ preview ก่อนแจ้ง
  const [modal_preview_close, setModalPreviewClose] = useState(null); //สำหรับ alert

  const modal_finish_card_ref = useRef(); //สำหรับ finish card หลังแจ้ง
  const [modal_finish_card_close, setModalFinishCardClose] = useState(null); //สำหรับ alert

  const [previewBtnDisabled, setPreviewBtnDisabled] = useState(false);

  const exportRef = useRef(null);

  const [resTicketId, setResTicketId] = useState("");
  const [resPassword, setResPassword] = useState("");

  useEffect(() => {
    getLocation();
  }, []);

  // useEffect(() => {
  //   setSelectedOrganization(8662);
  // }, []);

  useEffect(() => {
    if (Object.keys(globalData.mapPosition.current_coors).length !== 0) {
      document.getElementById("location").style.display = "none";

      setReportMap(
        <div class="col-12 ">
          <CreateMap />
        </div>
      );
    } else {
      document.getElementById("location").style.display = "block";
    }
  }, [globalData.mapPosition.current_coors]);

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      // console.log("Geolocation is not supported by this browser.")
    }
  };

  const showPosition = async (position) => {
    let current_coors = {
      lng: position.coords.longitude,
      lat: position.coords.latitude,
    };
    await dispatch(saveDataLatLon(current_coors));
  };

  useEffect(() => {
    funcAll.getProblemType("en").then((res) => {
      if (res["status"] === true) {
        setListProblemTypeAll(res["results"]);
      } else {
      }
    });
  }, [selectedProblemType]);

  const handleDropdownProblemTypeChange = (selected) => {
    setSelectedProblemType(selected);
  };

  const onChangePicture = (e) => {
    if (e.target.files[0]) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImgReport(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleClickUploadImg = (event) => {
    inputFile.current.click();
  };

  const handleBtnAlertClose = async () => {
    modalHide(modal_alert_close);
  };

  const handlePreviewClose = async () => {
    // console.log("preview close");
    modalHide(modal_preview_close);
  };

  const handleFinishCardClose = async () => {
    // console.log("finish card close");
    modalHide(modal_finish_card_close);
  };

  const modalShow = (mRef, setModals) => {
    const modal = new Modal(mRef.current, { keyboard: false });
    setModals(modal);
    modal.show();
  };

  const modalHide = (modal_hide) => {
    modal_hide.hide();
  };

  const alert_fail = (
    <span class="material-icons text-danger post-alert-icon my-3">cancel</span>
  );

  const setAlert = async (header_text, icon, description) => {
    setAlertHeader(header_text);
    setAlertContent(icon);
    setAlertDescription(description);
    modalShow(modal_alert_ref, setModalAlertClose);
  };

  const sendReportData = async (e) => {
    e.preventDefault();
    console.log("Success");
    // setDisableBtnSendData(true);
  };

  const view_Preview = (e) => {
    if (globalData.mapPosition.current_coors.length == 0) {
      setAlert(
        "Failed",
        alert_fail,
        "Please allow access to your current location to report issues"
      );
    } else if (detailReport.length < 1) {
      setTimeout(() => {
        setAlert("Failed", alert_fail, "Please type in the description");
      }, 1000);
    } else if (detailReport.length >= 1 && detailReport.length < 10) {
      setTimeout(() => {
        setAlert("Failed", alert_fail, "Too short description");
      }, 1000);
    } else if (selectedProblemType.length == 0) {
      setTimeout(() => {
        setAlert("Failed", alert_fail, "Please select a problem type");
      }, 1000);
    } else if (imgReport == noImg) {
      setAlert("Failed", alert_fail, "Please add a photo");
    } else {
      // console.log("ครบ");
      // console.log(
      //   "Problem Type : ",
      //   selectedProblemType["problem_types"][0]["name"]
      // );
      // console.log("Description : ", detailReport);
      // console.log("Img report : ", imgReport);
      // console.log("phone : ", phoneNumber);
      // console.log("email : ", email);

      // e.preventDefault()
      modalShow(modal_preview_ref, setModalPreviewClose);
    }
  };

  const view_Finish_Card = (e) => {
    // console.log("preview close & open finish card");
    // modalHide(modal_preview_close);
    // modalShow(modal_finish_card_ref, setModalFinishCardClose);

    setPreviewBtnDisabled(true);
    // console.log("submit Button clicked!");

    funcAll
      .sendData(
        detailReport,
        selectedProblemType["problem_types"][0],
        imgReport,
        globalData.mapPosition.current_coors.lat,
        globalData.mapPosition.current_coors.lng,
        selectedOrganization,
        phoneNumber,
        email,
        "en"
      )
      .then((res) => {
        // console.log('res',res);
        // console.log('ticket_id',res["results"].ticket_id);
        // console.log('password',res["results"].password);

        if (res["status"] === "success") {
          // console.log("preview close & open finish card");

          modalHide(modal_preview_close);
          modalShow(modal_finish_card_ref, setModalFinishCardClose);

          setResTicketId(res["results"].ticket_id);
          setResPassword(res["results"].password);
        } else if (res["status"] == "fail") {
          setAlert("Failed", alert_fail, "Please try again");
        }
      });

    // console.log("submit Button clicked!");

    // setPreviewBtnDisabled(true);
  };

  const DownloadTicketCard = (domElement) => {
    html2canvas(domElement).then((canvas) => {
      const image = canvas.toDataURL("png");
      const a = document.createElement("a");
      a.setAttribute("download", "ticket-card.png");
      a.setAttribute("href", image);
      a.click();

      // console.log(a);
      // console.log(image);
    });
  };

  return (
    <div className="report-container">
      <form
        id="myform"
        class="needs-validation"
        novalidate
        onSubmit={sendReportData}
      >
        <div className="container-title">
          <p className="txt-th title">Description</p>
          <p className="txt-th sub-title">
            (Please provide detailed information)
          </p>
        </div>

        <div className="was-validated">
          <textarea
            required
            type="text"
            className="form-control shadow-style input"
            rows="6"
            minLength={10}
            value={detailReport}
            onChange={(e) => setDetailReport(e.target.value)}
            placeholder="To ensure that authorities receive sufficient information, please provide at least 10 words about the incident you wish to report.
            e.g. I saw black smoke near alley A and I'm not sure if it's caused by a fire or something else."
          />
        </div>

        <div className="container-title pt-5">
          <p className="txt-th title">
            Channels for staff to contact for more information{" "}
          </p>
        </div>

        <div className="container-title">
          <input
            type="text"
            class="form-control shadow-style"
            placeholder="Mobile/Home/Work number (multiple numbers possible), etc."
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          ></input>
        </div>

        <div className="container-title pt-5">
          <p className="txt-th title">Email </p>
        </div>

        <div className="container-title">
          <input
            type="text"
            class="form-control shadow-style"
            placeholder="For example, abc@mail.com (email only)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></input>
        </div>

        <div className="container-title pt-5">
          <p className="txt-th title">Problem type</p>
        </div>

        <div
          className={`${listProblemTypeAll.length == 0 ? "disable-div" : ""}`}
        >
          <DropdownProblemType
            options={listProblemTypeAll}
            onSelect={handleDropdownProblemTypeChange}
            selectedOption={selectedProblemType}
            placeholder="Select problem type"
          />
        </div>

        <div className="container-title pt-5">
          <p className="txt-th title">Location</p>
          <p className="txt-th sub-title">
            (Type a location or click on the map to select the desired
            location.)
          </p>
        </div>

        {/* ******** ส่วนของตัวเตือนเปิด Location ********** */}

        <div id="location">
          <div class="text-left bg-danger text-white p-2 d-flex justify-content-center">
            <span class="material-icons pe-2">error_outline</span>
            We noticed that you have not yet granted permission for us to access
            your location in Google Maps. To fully utilize the features of our
            app, we require access to your location.
          </div>
        </div>

        {/* ******** ส่วนของตัวเตือนเปิด Location ********** */}

        {reportMap}

        <div className="container-title pt-5">
          <p className="txt-th title">Photo</p>
        </div>

        <div className="container-bg-img-report mt-2 mb-5">
          <img
            className={`img-report ${imgReport != noImg ? "have-img" : ""}`}
            src={imgReport}
            onClick={handleClickUploadImg}
          />
          <div className="btn-add-img" onClick={handleClickUploadImg}>
            <p className="txt-th">Add photo</p>
          </div>
          <input
            type="file"
            id="file"
            required
            onChange={onChangePicture}
            ref={inputFile}
            accept="image/*"
            style={{ display: "none" }}
          />
        </div>

        <button
          className="btn-report"
          // type="submit"
          onClick={view_Preview}
        >
          <p>Submit</p>
        </button>

        {/* ******* ส่วนของ popup preview ************* */}
        <div
          class="modal fade"
          ref={modal_preview_ref}
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-dialog-custom">
            <div class="modal-content">
              <div className="modal-body text-center p-0">
                <p className="title-preview mt-3">Preview Report</p>
              </div>

              <div class="container-detail-preview2">
                <div className="container-sub-detail-preview mt-3">
                  <p className="sub-title">Problem type</p>
                  {selectedProblemType.length != 0 ? (
                    <>
                      <p className="sub-title-detail">
                        {selectedProblemType["problem_types"][0]["name"]}
                      </p>
                    </>
                  ) : null}
                </div>

                <div className="container-sub-detail-preview mt-2">
                  <p className="sub-title">Description</p>
                  <p className="sub-title-detail">{detailReport}</p>
                </div>

                {phoneNumber.length != 0 ? (
                  <>
                    <div className="container-sub-detail-preview mt-2">
                      <p className="sub-title">Phone number</p>
                      {" "}
                      <p className="sub-title-detail">{phoneNumber}</p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="container-sub-detail-preview mt-0">
                      <p className="sub-title-none">Phone number</p>
                      {" "}
                      <p className="sub-title-detail-none">{phoneNumber}</p>
                    </div>
                  </>
                )}

                {email.length != 0 ? (
                  <>
                    <div className="container-sub-detail-preview mt-2">
                      <p className="sub-title">Email</p>
                      {" "}
                      <p className="sub-title-detail">{email}</p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="container-sub-detail-preview mt-0">
                      <p className="sub-title-none">Email</p>
                      {" "}
                      <p className="sub-title-detail-none">{email}</p>
                    </div>
                  </>
                )}

                <div className="container-sub-detail-preview mt-2">
                  <p className="sub-title">Organization</p>
                  <p className="sub-title-detail">
                    กรมป้องกันและบรรเทาสาธารณภัย
                  </p>
                </div>

                <div className="container-preview-img-report mt-2">
                  <p>Photo</p>
                  <img src={imgReport}></img>
                </div>

                <div className="container-btn-preview mt-3">
                  <a className="btn-cancel" onClick={handlePreviewClose}>
                    <p>Back</p>
                  </a>

                  <button
                    className="btn-report"
                    // type="submit"
                    onClick={view_Finish_Card}
                    disabled={previewBtnDisabled}
                  >
                    <p>Submit</p>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ******* ส่วนของ popup preview ************* */}

        {/* ******* ส่วนของ popup finish card ************* */}
        <div
          class="modal fade"
          ref={modal_finish_card_ref}
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-dialog-custom">
            <div class="modal-content modal-content-finish-card">
              <div className="parent" ref={exportRef} id="finish-card">
                <div className="modal-body modal-body-header text-center">
                  <div className="finish-card-logo">
                    <img className="logo-traffy mt-3" src={ic_porpor}></img>
                    <img className="logo-fondue-app mt-3" src={ic_fondue}></img>
                  </div>
                  <p className="header-finish-card my-2">
                    Thank you for reporting the issue with us!
                  </p>
                  <p className="header-finish-card-detail mb-1">
                    Your report has been submitted.
                  </p>
                  <p className="header-finish-card-detail">
                    Thank you for helping make our city a better place to live.
                  </p>
                </div>

                <div className="modal-body-ticket text-center p-0">
                  <p className="title-finish-card mt-3">
                    Ticket ID: {resTicketId}
                  </p>
                </div>

                <div class="container-detail-finish-card2">
                  <div className="container-sub-detail-preview mt-3">
                    <p className="sub-title">Problem types</p>
                    {selectedProblemType.length != 0 ? (
                      <>
                        {" "}
                        <p className="sub-title-detail">
                          {selectedProblemType["problem_types"][0]["name"]}
                        </p>
                      </>
                    ) : null}
                  </div>

                  <div className="container-sub-detail-preview mt-2">
                    <p className="sub-title">Description</p>
                    <p className="sub-title-detail">{detailReport}</p>
                  </div>

                  {/* <div className="container-sub-detail-preview mt-2"> */}
                  {/* <p className="sub-title">Phone number</p> */}
                  {phoneNumber.length != 0 ? (
                    <>
                      <div className="container-sub-detail-preview mt-2">
                        <p className="sub-title">Phone number</p>{" "}
                        <p className="sub-title-detail">{phoneNumber}</p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="container-sub-detail-preview mt-0">
                        <p className="sub-title-none">Phone number</p>{" "}
                        <p className="sub-title-detail-none">{phoneNumber}</p>
                      </div>
                    </>
                  )}
                  {/* </div> */}

                  {/* <div className="container-sub-detail-preview mt-2"> */}
                  {/* <p className="sub-title">Email</p> */}
                  {email.length != 0 ? (
                    <>
                      <div className="container-sub-detail-preview mt-2">
                        <p className="sub-title">Email</p>{" "}
                        <p className="sub-title-detail">{email}</p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="container-sub-detail-preview mt-0">
                        <p className="sub-title-none">Email</p>{" "}
                        <p className="sub-title-detail-none">{email}</p>
                      </div>
                    </>
                  )}
                  {/* </div> */}

                  <div className="container-sub-detail-preview mt-2">
                    <p className="sub-title">Organization</p>
                    <p className="sub-title-detail">
                      กรมป้องกันและบรรเทาสาธารณภัย
                    </p>
                  </div>

                  <div className="container-preview-img-report mt-2">
                    <p>Photo</p>
                    <img src={imgReport}></img>
                  </div>

                  <div className="container-btn-save-social mt-2">
                    <a
                      className="btn-save-share"
                      type="button"
                      onClick={() => DownloadTicketCard(exportRef.current)}
                    >
                      <img className="btn-save-img" src={save} />
                    </a>
                  </div>

                  <div className="container-password-follow-up mt-3">
                    <p className="sub-title-detail-follow">
                      You can check the progress of your report at
                    </p>
                    <p className="sub-title-detail-link">
                      https://c.traffy.in.th/{resTicketId}
                    </p>
                    <p className="sub-title-detail-password">
                      Password {resPassword}
                    </p>
                  </div>

                  <div className="container-alert-follow-up mt-3 mb-3">
                    <p className="sub-title">
                      *Please remember or keep the Ticket ID and password
                    </p>
                    <p className="sub-title-detail">
                      to use to check your report.
                    </p>
                  </div>
                </div>
              </div>

              <div className="container-btn-finish-card mt-3">
                <a
                  // type="submit"
                  className="btn-finish-card"
                  onClick={handleFinishCardClose}
                >
                  <p>Finish</p>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* ******* ส่วนของ popup finish card ************* */}
      </form>

      {/* ******* ส่วนของ Alert ************* */}
      <div
        className="modal fade"
        ref={modal_alert_ref}
        id="stateUpdate"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content bg-transparent border-0">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center">
                <div className="card post-alert-box rounded-4">
                  <div className="card-body">
                    <p className="card-text p-0 m-0">{alert_content}</p>
                    <h4 className="txt-title-alert">{alert_header}</h4>
                    <h6 className="txt-detail-alert">{alert_description}</h6>
                    <button
                      type="button"
                      className="btn-alert"
                      onClick={handleBtnAlertClose}
                    >
                      <p>OK</p>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ******* ส่วนของ Alert ************* */}
    </div>
  );
}
